import { FormControl } from '@angular/forms';

// tslint:disable-next-line:max-line-length
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export function customEmailValidator(formControl: FormControl) {
  return EMAIL_REGEX.test(formControl.value) ? null : {
    email: {
      valid: false
    }
  };
}

export function customEmailNFValidator(emailString: string) {
  return EMAIL_REGEX.test(emailString) ? null : {
    email: {
      valid: false
    }
  };
}
